export default __webpack_public_path__ + "static/media/Icon_Class_Farmer.bdd26db3.png";